"use client";
//#region packages/@mantine/core/src/core/utils/noop/noop.ts
const noop = () => {};
//#endregion
export { noop };

//# sourceMappingURL=noop.mjs.map